<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการข้อกำหนดและนโยบายข้อมูลส่วนบุคคล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อกำหนดและนโยบายข้อมูลส่วนบุคคล
          </a>
        </li>
        <li class="active">จัดการข้อกำหนดและนโยบายข้อมูลส่วนบุคคล</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <!-- <div class="row"> -->
                      <div class="col-md-12">
                        <el-form size="mini">
                          <el-form-item label="รายละเอียดข้อกำหนดและนโยบายข้อมูลส่วนบุคคล (Thai)">
                            <vue-editor v-model="form.content_th" :editor-toolbar="customToolbar"></vue-editor>
                          </el-form-item>
                          <el-form-item label="รายละเอียดข้อกำหนดและนโยบายข้อมูลส่วนบุคคล (Eng)">
                            <vue-editor v-model="form.content_en" :editor-toolbar="customToolbar"></vue-editor>
                          </el-form-item>
                        </el-form>
                        <p>แก้ไขล่าสุดเมื่อ {{moment(form.updated_at).add(543, 'Y').format('DD-MM-YYYY HH:mm:ss')}} โดย {{form.updated_by}}</p>
                      </div>
                    <!-- </div> -->
                    <div class="box-footer">
                      <el-button type="primary" @click="submitForm()">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
.mytextarea {
    margin:10px 0;
    height:200px;
}</style>
<script>
import { mapState, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data() {
    return {
      label_position: "top",
      form: {
        content_th: '',
        content_en: '',
        updated_at: '',
        updated_by: '',
        current_user_id: this.$cookies.get('user_nbtc').admin_id
      },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
        [{ 'direction': 'rtl' }], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        ['clean']         
      ]
    };
  },
  created() {
    this.$store.dispatch('PrivacyDataPolicyStore/getPrivacy')
  },
  computed: {
    ...mapState({
      content_th : store => store.PrivacyDataPolicyStore.content_th,
      content_en : store => store.PrivacyDataPolicyStore.content_en,
      updated_by : store => store.PrivacyDataPolicyStore.updated_by,
      updated_at : store => store.PrivacyDataPolicyStore.updated_at
    })
  },
  mounted() {
    this.form.content_th = this.content_th
    this.form.content_en = this.content_en
    this.form.updated_by = this.updated_by
    this.form.updated_at = this.updated_at
  },
  watch: {
    content_th : {
      handler : function(reload, empty) {
        this.form.content_th = reload
      }
    },
    content_en : {
      handler : function(reload, empty) {
        this.form.content_en = reload
      }
    },
    updated_by : {
      handler : function(reload, empty) {
        this.form.updated_by = reload
      }
    },
    updated_at : {
      handler : function(reload, empty) {
        this.form.updated_at = reload
      }
    }
  },
  methods: {
    ...mapActions({
      savePrivacy: "PrivacyDataPolicyStore/savePrivacy"
    }),
    submitForm() {
      this.savePrivacy(this.form);
    }
  }
};
</script>
